import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IGlobalMessagePreviewProps } from './GlobalMessagePreview.interface';
import { buildPreview } from './utils';

const GlobalMessagePreview: FC<IGlobalMessagePreviewProps> = ({ className, title, content }) => {
  const { t } = useTranslation();
  const [preview, setPreview] = useState<string>();

  useEffect(() => {
    setPreview(buildPreview(content));
  }, [t, content]);

  return (
    <iframe className={className} title={title} srcDoc={preview} sandbox="allow-same-origin" />
  );
};

export default GlobalMessagePreview;
